export { default as FontAwesome } from './FontAwesome'
